import React from 'react';
import { motion } from 'framer-motion';
export function OpeningHook() {
  return <section className="py-16 md:py-24 bg-cream-dark/30" data-id="element-103">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-104">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-105">
          <p className="text-xl md:text-2xl font-playfair italic text-brown-heading leading-relaxed mb-8" data-id="element-106">
            "Son las 2 de la mañana. Tu bebé arde en fiebre, llora
            desconsoladamente por el dolor de encías o se retuerce por un cólico
            que no lo deja descansar. Miras el gabinete de medicinas y solo
            encuentras frascos llenos de advertencias, colorantes rojos
            artificiales y jarabes que solo 'apagan' los síntomas sin ayudar a
            su pequeño cuerpo."
          </p>

          <div className="w-16 h-px bg-gold mx-auto mb-8" data-id="element-107"></div>

          <p className="text-lg text-brown-body leading-relaxed" data-id="element-108">
            No tienes por qué sentirte impotente. Existe una forma de calmar el
            llanto y proteger la salud de tu hijo usando la sabiduría de la
            naturaleza y protocolos de seguridad probados.
          </p>
        </motion.div>
      </div>
    </section>;
}